import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import * as React from "react";

import { PageLayout } from "@/shared/components";
import { FileRecord } from "@/shared/domain/files";
import { useDeleteFilesMutation } from "@/shared/domain/files/hooks";
import { type SelectionOption } from "@/shared/foundation/primitives/Table";

import { FilesList } from "./FilesList";

/**
 * Top-level `/files` route element.
 */
export function FilesPage() {
  const { mutate: deleteFiles } = useDeleteFilesMutation();

  const selectionOptions = React.useMemo<SelectionOption<FileRecord>[]>(
    () => [
      {
        name: "Delete files",
        icon: <DeleteOutlineIcon fontSize="small" />,
        action: ({ selected }) => {
          if (selected.length === 0) {
            return;
          }
          const ok = window.confirm(
            `Delete ${selected.length} file${selected.length === 1 ? "" : "s"}? This cannot be undone.`,
          );
          if (!ok) {
            return;
          }
          deleteFiles({
            fileIds: selected.map((file) => file.file_id),
          });
        },
      },
    ],
    [deleteFiles],
  );

  return (
    <PageLayout title="Roboto - Files" headerContentLeft="Files">
      <FilesList selectionOptions={selectionOptions} />
    </PageLayout>
  );
}
